import { DecimalPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'neonCurrency',
    standalone: true
})

export class NeonCurrencyPipe implements PipeTransform {
    private decimalPipe = new DecimalPipe('el-GR');

    transform(value: number | undefined, currency: string = '€', spaceBetween: boolean = false, locale: string = 'el-GR', digitsInfo: string = '0.0-2'): string | null {
        if (!value) {
            return null;
        }

        console.log(locale)
        const formattedValue = this.decimalPipe.transform(value, digitsInfo, locale);
        return spaceBetween ? `${currency} ${formattedValue}` : `${currency}${formattedValue}`;
    }
}